var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.28,
    d: "M12 2.88 4 8l8 5.12"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2.88,
    r: 2.24,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 8,
    r: 2.24,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13.12,
    r: 2.24,
    fill: "#000"
  })));
};
export default SvgShare;